import { render, staticRenderFns } from "./SolicitudesAR.vue?vue&type=template&id=40c71b2e&"
import script from "./SolicitudesAR.vue?vue&type=script&lang=js&"
export * from "./SolicitudesAR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports